function normalizeTaskIdentityPart(value) {
  if (typeof value === 'string') return value.trim();
  if (value === null || value === undefined) return '';
  return String(value).trim();
}

export function getTaskTimestamp(task) {
  return (
    task?.completedAt
    || task?.startedAt
    || task?.createdAt
    || 0
  );
}

export function getTaskIdentity(task, fallbackAgentId = '') {
  const agentId = normalizeTaskIdentityPart(task?.agentId || fallbackAgentId);
  const taskId = normalizeTaskIdentityPart(task?.id);

  if (agentId && taskId) return `${agentId}::${taskId}`;
  if (taskId) return `task::${taskId}`;

  const label = normalizeTaskIdentityPart(task?.label || task?.instruction || 'task');
  const timestamp = getTaskTimestamp(task);
  return `${agentId || 'unknown'}::${label}::${timestamp}`;
}

export function isSameTask(left, right) {
  if (!left || !right) return false;
  return getTaskIdentity(left) === getTaskIdentity(right);
}

export function findTaskByIdentity(tasks, target, fallbackAgentId = '') {
  const identity = getTaskIdentity(target, fallbackAgentId);
  return tasks.find((task) => getTaskIdentity(task, fallbackAgentId) === identity) || null;
}

export function dedupeTasksByIdentity(tasks) {
  const deduped = new Map();

  for (const task of tasks) {
    if (!task) continue;

    const identity = getTaskIdentity(task);
    const existing = deduped.get(identity);
    if (!existing || getTaskTimestamp(task) >= getTaskTimestamp(existing)) {
      deduped.set(identity, task);
    }
  }

  return [...deduped.values()];
}
